/* eslint-disable class-methods-use-this */
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

export class MolecularService {
  /**
   * @name initialize
   * @methodOf MolecularService
   * @description private method to initialize data
   */
  _initialize = () => {
    this.data.query.mode = 'auto';
    this.data.query.text = '';

    this._initElements();
    this._initGroups();
  };

  /**
   * @name initialize
   * @methodOf MolecularService
   * @description public method to initialize data
   */
  initialize = () => {
    if (this._initialized) {
      return;
    }
    this._initialized = true;
    this._initialize();
  };

  data = {
    utils: { initialize: this._initialize },
    query: {},
    metaColumnsItems: [],
    metaRowsItems: [],
    specialGroupItems: [],
    metalicGroupItems: [],
    elementsItems: [],
  };

  _initialized = false;

  _groupsUnfiltered = []; // The groups list unfiltered from API

  _elementsItems = [];

  _getGroups = () => MessageBroker.send(RequestUrls.molFormGroupConstraints);

  _getElements = () => MessageBroker.send(RequestUrls.molFormPeriodicTable);

  /**
   * @name initElements
   * @methodOf MolecularService
   * @description get all elements
   */
  _initElements = async () => {
    // Block execution if elementsRows is already populated
    if (this._elementsItems.length > 0) {
      // Make a copy of elementsRows to leave it intact
      this.data.elementsItems = cloneDeep(this._elementsItems);
      return;
    }
    // Send request only first time
    await this._getElements().then((response) => {
      this._elementsItems = response;
      this.data.elementsItems = cloneDeep(this._elementsItems);
    });
  };

  /**
   * @name initGroups
   * @methodOf MolecularService
   * @description get all groups
   */
  _initGroups = async () => {
    // Block execution if groupsUnfiltered is already populated
    if (this._groupsUnfiltered.length > 0) {
      // Make a copy of groupsUnfiltered to leave it intact
      this._aggregateGroups(cloneDeep(this._groupsUnfiltered));
      return;
    }
    // Send request only first time
    await this._getGroups().then((response) => {
      this._groupsUnfiltered = response;
      this._aggregateGroups(cloneDeep(this._groupsUnfiltered));
    });
  };

  /**
   * @name aggregateGroups
   * @methodOf MolecularService
   * @param {integer} groupsRaw Array of groups unfiltered
   * @description Iterate and aggregate groups with spefici logic
   */
  _aggregateGroups = (groupsRaw) => {
    // Clean groups
    this._resetGroups();

    forEach(groupsRaw, (groupsList) => {
      this._assignGroups(groupsList);
    });
  };

  /**
   * @name assignGroups
   * @methodOf MolecularService
   * @description Assign items to a specific group
   */
  _assignGroups = (groupsList) => {
    const { id } = groupsList;

    // Define multiple exceptions
    const isMetalic = id === 'select_by_metallic_props_1' || id === 'select_by_metallic_props_2' || id === 'select_by_metallic_props_3';

    // Check the exceptions
    if (id === 'select_by_period') {
      this.data.metaRowsItems = groupsList.groups;
    } else if (id === 'select_by_group') {
      this.data.metaColumnsItems = groupsList.groups;
    } else if (id === 'select_on_special_1') {
      this.data.specialGroupItems = groupsList.groups;
    } else if (isMetalic) {
      this.data.metalicGroupItems.push(groupsList);
    }
  };

  /**
   * @name resetGroups
   * @methodOf aggregateGroups
   * @description Reset all groups to empty initial status
   */

  _resetGroups = () => {
    this.data.metaColumnsItems = [];
    this.data.metaRowsItems = [];
    this.data.specialGroupItems = [];
    this.data.metalicGroupItems = [];
  };
}

const Molecular = new MolecularService();
export default Molecular;
